/**
 * sanitizeTex replaces $...$ and $$...$$ TeX delimiters with \(...\) and
 * \[...\] delimiters.
 */
export const sanitizeTex = (content: string): string => {
    // NOTE: Negative look-behind tokens are not supported on every browser
    // so this is a little less intuitive but the explanation:
    // - (?:([^\\])\$) matches a "$" character that isn't preceded by a "\".
    //   Without negative look behind, we always match an extra character
    //   preceding the $. We'll capture it and stitch it back in the replace
    //   function.
    // - ([\s\S]*?) matches any character (new-line or not), adding the ? makes
    //   it match as few as possible.

    // Replace $$...$$ with \[...\]
    content = content.replace(
        /(?:(^|[^\\])\$\$)([\s\S]*?)(?:([^\\])\$\$)/gm,
        "$1\\[$2$3\\]",
    );
    // Replace $...$ with \(...\)
    content = content.replace(
        /(?:(^|[^\\])\$)([\s\S]*?)(?:([^\\])\$)/gm,
        "$1\\($2$3\\)",
    );

    return content;
};
